import styled from 'styled-components'

export const DragAndDrop = styled.div`
  button {
    height: 40px;
    width: 32px;
    padding: 0;
    color: #757575 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
`

export const TableBody = styled.div`
  font-size: 14px;
  color: #363636;
  .ant-col {
    padding: 10px 0;
    padding-right: 13px;
    border-bottom: 1px solid #d9d9d9;
    line-height: 30px;
    input {
      padding: 4px 5px 4px 11px;
    }
  }
`

export const Wrapper = styled.div`
  margin-top: 24px;
  .ant-col {
    border-bottom: none;
    padding: 8px 16px 8px 0;
  }
  input {
    height: 40px;
  }
  > button {
    margin-top: 8px;
    color: #0085ff !important;
    border: none;
    box-shadow: none;
    padding: 0;
    font-weight: 700;
    svg {
      margin-right: 10px;
    }
    &:hover {
      opacity: 0.7;
    }
  }
`

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #757575;
  margin-bottom: 8px;
`

export const CorrectAnswer = styled.div<{ correct: boolean }>`
  button {
    border: 2px solid ${(props) => (props.correct ? '#6ECDA5' : '#D9D9D9')} !important;
    color: ${(props) => (props.correct ? '#00B47C' : '#4C4C4C')} !important;
    border-radius: 8px;
    height: 40px;
    width: 40px;
    padding: 0;
    svg {
      font-size: 16px;
      margin-top: 3px;
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
`

export const RemoveAnswer = styled.div`
  button {
    border: none;
    background-color: #f0f0f0 !important;
    color: #4c4c4c !important;
    border-radius: 8px;
    height: 40px;
    width: 40px;
    svg {
      font-size: 16px;
      margin-top: 3px;
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
`
